// importing vue class component
import Component from "vue-class-component";

// registering additional router hooks with their names
Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate", "beforeRouteLeave"]);
